/**
 * HL: supplements collection filter navigation without full page reload.
 * Uses Shopify Section Rendering API; animates active-filter row + grid shift.
 */
(function () {
  'use strict';

  var COLLECTION_RE = /^\/collections\/(nutritional-supplements|supplements-brand|vendors|protocols|gifts|services|all|detoxify|nourish|heal-repair|thrive)/;

  function getRoot() {
    return document.querySelector(
      '.hl-supplements-collection[data-hl-filter-ajax], .hl-supplements-collection[data-hl-search-filter-ajax]'
    );
  }

  var root = getRoot();
  if (!root) return;

  var isSearch = root.hasAttribute('data-hl-search-filter-ajax');
  if (isSearch) {
    if (!/^\/search/.test(window.location.pathname)) return;
    if (!new URLSearchParams(window.location.search).get('q')) return;
  } else if (!COLLECTION_RE.test(window.location.pathname)) {
    return;
  }

  function mainCollectionPath() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (/^\/collections\/supplements-brand-/.test(path)) {
      return '/collections/nutritional-supplements';
    }
    if (COLLECTION_RE.test(path)) return path;
    return '/collections/nutritional-supplements';
  }

  var MAIN_COLLECTION = mainCollectionPath();
  var BRAND_TAG_PREFIX = 'hl-brand-';

  var sectionEl = document.querySelector('.shopify-section--collection-template');
  if (!sectionEl || !sectionEl.id) return;

  var sectionId = sectionEl.id.replace(/^shopify-section-/, '');
  var pending = false;
  var animMs = 320;
  var sectionFetchAborters = { supplement: null, warm: null };

  function abortBackgroundSectionFetches() {
    ['supplement', 'warm'].forEach(function (kind) {
      if (sectionFetchAborters[kind]) {
        sectionFetchAborters[kind].abort();
        sectionFetchAborters[kind] = null;
      }
    });
  }

  function isAbortError(err) {
    return err && (err.name === 'AbortError' || err.code === 20);
  }

  function searchClearUrl() {
    var q = new URLSearchParams(window.location.search).get('q');
    return q ? '/search?q=' + encodeURIComponent(q) : '/search';
  }

  function normalizeSearchNavUrl(url) {
    if (!url || url.indexOf('/search') !== 0) return url;
    var u = new URL(url, window.location.origin);
    var q = u.searchParams.get('q');
    if (!q) return url;

    var hasProductType = u.searchParams.getAll('filter.p.product_type').length > 0;
    var hasCatalogTag = false;
    u.searchParams.getAll('filter.p.tag').forEach(function (tag) {
      if (['Services', 'Grocery', 'Gifts'].indexOf(tag) >= 0) hasCatalogTag = true;
    });
    var hasBrandTag = u.searchParams.getAll('filter.p.tag').some(isBrandTag);

    if (hasProductType || hasCatalogTag || hasBrandTag) {
      if (!u.searchParams.get('type')) u.searchParams.set('type', 'product');
    }

    u.searchParams.set('options[unavailable_products]', 'show');
    return u.pathname + u.search;
  }

  function searchFilterParamsFromSource(searchSource) {
    var qs = searchSource || window.location.search || '';
    if (typeof qs !== 'string') qs = String(qs);
    if (qs.indexOf('/') === 0 || qs.indexOf('http') === 0) {
      try {
        qs = new URL(qs, window.location.origin).search;
      } catch (e) {
        qs = '';
      }
    }
    if (qs.charAt(0) === '?') qs = qs.slice(1);
    return new URLSearchParams(qs);
  }

  function brandTagFromFilterLink(link) {
    if (!link) return '';
    var tag = link.getAttribute('data-hl-brand-tag');
    if (tag) return tag;
    var url = link.getAttribute('data-url') || link.getAttribute('href') || '';
    if (!url) return '';
    try {
      var tags = new URL(url, window.location.origin).searchParams.getAll('filter.p.tag');
      for (var i = 0; i < tags.length; i++) {
        if (['Services', 'Grocery', 'Gifts'].indexOf(tags[i]) < 0) return tags[i];
      }
    } catch (e) {}
    return '';
  }

  function applySearchProductFiltersFromUrl(searchSource) {
    if (!isSearch) return;
    var params = searchFilterParamsFromSource(searchSource);
    var supplements =
      params.get('filter.p.product_type') === 'Supplements' ||
      params.getAll('filter.p.product_type').indexOf('Supplements') >= 0;
    var catalogTag = '';
    params.getAll('filter.p.tag').forEach(function (tag) {
      if (['Services', 'Grocery', 'Gifts'].indexOf(tag) >= 0) catalogTag = tag;
    });
    var brandTags = params.getAll('filter.p.tag').filter(isBrandTag);

    var root = getRoot();
    if (!root) return;

    if (!supplements && !catalogTag && !brandTags.length) {
      root.querySelectorAll('.hl-supplements-card[data-hl-product-type]').forEach(function (card) {
        card.style.display = '';
      });
      var articlesReset = root.querySelector('.hl-search-results__articles');
      if (articlesReset) articlesReset.style.display = '';
      return;
    }

    var visible = 0;
    root.querySelectorAll('.hl-supplements-card[data-hl-product-type]').forEach(function (card) {
      var show = true;
      var type = card.getAttribute('data-hl-product-type') || '';
      var tagList = (card.getAttribute('data-hl-product-tags') || '').split('|');
      if (supplements && type !== 'Supplements') show = false;
      if (catalogTag) {
        var tagMatch = tagList.indexOf(catalogTag) >= 0 || type === catalogTag;
        if (!tagMatch) show = false;
      }
      if (brandTags.length) {
        var brandMatch = brandTags.some(function (brandTag) {
          return tagList.indexOf(brandTag) >= 0;
        });
        if (!brandMatch) show = false;
      }
      card.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });

    var articles = root.querySelector('.hl-search-results__articles');
    if (articles && (supplements || catalogTag || brandTags.length)) articles.style.display = 'none';

    var noMatches = root.querySelector('.has-sidebar-option > .container > .quote');
    if (visible === 0) {
      if (!noMatches) {
        var container = root.querySelector('.has-sidebar-option > .container');
        if (container) {
          noMatches = document.createElement('p');
          noMatches.className = 'quote';
          noMatches.textContent = 'No products found in this collection';
          container.appendChild(noMatches);
        }
      } else {
        noMatches.style.display = '';
      }
    } else if (noMatches) {
      noMatches.style.display = 'none';
    }
    syncSearchResultsCount();
  }
  window.hlApplySearchProductFiltersFromUrl = applySearchProductFiltersFromUrl;

  function syncSearchResultsCount() {
    if (!isSearch) return;
    var countEl = document.querySelector('.hl-search-results__count');
    if (!countEl) return;
    var params = searchFilterParamsFromSource();
    var q = params.get('q');
    if (!q) return;
    var root = getRoot();
    if (!root) return;
    var type = params.get('type') || '';
    var articlesOnly = type === 'article' || (type.indexOf('article') >= 0 && type.indexOf('product') < 0);
    var visible = 0;
    if (!articlesOnly) {
      root.querySelectorAll('.hl-supplements-card[data-hl-product-type]').forEach(function (card) {
        if (card.style.display !== 'none') visible += 1;
      });
    }
    var articles = root.querySelector('.hl-search-results__articles');
    if (articles && articles.style.display !== 'none') {
      visible += articles.querySelectorAll('[data-hl-search-article-row]').length;
    }
    countEl.textContent = visible + ' results for "' + q + '"';
    syncSearchFilterCounts();
  }
  window.hlSyncSearchResultsCount = syncSearchResultsCount;

  function syncSearchFilterCounts() {
    if (!isSearch) return;
    var root = getRoot();
    if (!root) return;
    var brandCounts = {};
    var typeCounts = {};
    var catalogCounts = {};
    var catalogTags = ['Services', 'Grocery', 'Gifts'];
    root.querySelectorAll('.hl-supplements-card[data-hl-product-type]').forEach(function (card) {
      if (card.style.display === 'none') return;
      var type = card.getAttribute('data-hl-product-type') || '';
      if (type) typeCounts[type] = (typeCounts[type] || 0) + 1;
      (card.getAttribute('data-hl-product-tags') || '').split('|').forEach(function (tag) {
        if (!tag) return;
        if (catalogTags.indexOf(tag) >= 0) catalogCounts[tag] = (catalogCounts[tag] || 0) + 1;
        var brands = window.hlSupplementsBrands;
        if (!brands) return;
        for (var i = 0; i < brands.length; i++) {
          if (brands[i].filter_tag === tag) {
            brandCounts[tag] = (brandCounts[tag] || 0) + 1;
            break;
          }
        }
      });
    });
    root.querySelectorAll('[data-hl-brand-filter] a[data-hl-brand-tag] .hl-filter-count').forEach(function (el) {
      var link = el.closest('a[data-hl-brand-tag]');
      if (!link) return;
      var tag = link.getAttribute('data-hl-brand-tag');
      var n = brandCounts[tag] || 0;
      el.textContent = '(' + n + ')';
    });
    root.querySelectorAll('[data-hl-catalog-type-filter] a[data-hl-catalog-type] .hl-filter-count').forEach(function (el) {
      var link = el.closest('a[data-hl-catalog-type]');
      if (!link) return;
      var type = link.getAttribute('data-hl-catalog-type');
      var n = 0;
      if (type === 'Supplements') n = typeCounts.Supplements || 0;
      else if (catalogTags.indexOf(type) >= 0) n = catalogCounts[type] || 0;
      el.textContent = '(' + n + ')';
    });
  }
  window.hlSyncSearchFilterCounts = syncSearchFilterCounts;

  function isBrandTag(tag) {
    if (!tag) return false;
    if (['Services', 'Grocery', 'Gifts'].indexOf(tag) >= 0) return false;
    if (tag.indexOf('hl-brand-') === 0) return true;
    var links = document.querySelectorAll('[data-hl-brand-filter] a[data-filter-input]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].hasAttribute('data-hl-brand-clear-all')) continue;
      if (brandTagFromFilterLink(links[i]) === tag) return true;
    }
    return false;
  }

  function currentBrandTags() {
    var url = new URL(window.location.href);
    var tags = url.searchParams.getAll('filter.p.tag').filter(isBrandTag);
    if (tags.length) return tags;
    var match = window.location.pathname.match(/\/collections\/supplements-brand-([^/?]+)/);
    if (match) return [BRAND_TAG_PREFIX + match[1]];
    return [];
  }

  function buildBrandFilterUrl(nextBrandTags) {
    var url = new URL(MAIN_COLLECTION, window.location.origin);
    var current = new URL(window.location.href);

    if (current.searchParams.get('sort_by')) {
      url.searchParams.set('sort_by', current.searchParams.get('sort_by'));
    }

    current.searchParams.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 && key !== 'filter.p.tag') {
        url.searchParams.append(key, value);
      }
    });

    current.searchParams.getAll('filter.p.tag').forEach(function (tag) {
      if (!isBrandTag(tag)) url.searchParams.append('filter.p.tag', tag);
    });

    nextBrandTags.forEach(function (tag) {
      url.searchParams.append('filter.p.tag', tag);
    });

    return url.pathname + url.search;
  }

  function brandTagToggleUrl(link) {
    var tag = link.getAttribute('data-hl-brand-tag');
    if (!tag) return null;
    var tags = currentBrandTags().slice();
    var idx = tags.indexOf(tag);
    if (idx >= 0) tags.splice(idx, 1);
    else tags.push(tag);
    return buildBrandFilterUrl(tags);
  }

  function clearBrandTagsUrl() {
    return buildBrandFilterUrl([]);
  }

  function filterNavLink(el) {
    if (!el || el.hasAttribute('data-disabled')) return null;
    var scope = getRoot();
    if (!scope || !scope.contains(el)) return null;
    if (el.matches('[data-hl-search-clear-all], [data-hl-clear-all-filters], .hl-active-filters__clear')) return el;
    if (el.closest('.hl-active-filter-chip__link')) return el;
    if (el.closest('.hl-filter-all-types, .hl-filter-all-brands') && el.tagName === 'A') return el;
    if (el.closest('[data-hl-brand-filter] a[data-filter-input]')) return el;
    if (el.closest('.hl-sidebar-filters a[data-filter-input]')) return el;
    if (isSearch && el.tagName === 'A') {
      var href = el.getAttribute('href') || el.dataset.url || '';
      if (
        href.indexOf('/search') === 0 &&
        (href.indexOf('filter.') >= 0 ||
          href.indexOf('type=') >= 0 ||
          el.closest('.hl-sidebar-filters, .hl-active-filters, [data-hl-catalog-type-filter], [data-hl-brand-filter]'))
      ) {
        return el;
      }
    }
    return null;
  }

  function clearAllFiltersUrl() {
    var url = new URL(window.location.href);
    url.searchParams.forEach(function (_value, key) {
      if (key.indexOf('filter.') === 0) url.searchParams.delete(key);
    });
    return url.pathname + url.search;
  }

  function navUrl(link) {
    if (isSearch) {
      if (link.matches('[data-hl-search-clear-all], .hl-active-filters__clear')) return searchClearUrl();
      return normalizeSearchNavUrl(link.dataset.url || link.getAttribute('href'));
    }
    if (link.matches('.hl-active-filters__clear') || link.hasAttribute('data-hl-clear-all-filters')) {
      return clearAllFiltersUrl();
    }
    if (link.hasAttribute('data-hl-brand-clear-all') || link.closest('.hl-filter-all-brands')) {
      return clearBrandTagsUrl();
    }
    if (link.hasAttribute('data-hl-brand-tag')) return brandTagToggleUrl(link);
    var catalogUrl = catalogTypeNavUrl(link);
    if (catalogUrl) return catalogUrl;
    var url = link.dataset.url || link.getAttribute('href');
    if (url && link.closest('[data-hl-brand-filter]') && url.indexOf('/collections/supplements-brand-') >= 0) {
      var tagMatch = url.match(/\/collections\/supplements-brand-([^/?]+)/);
      if (tagMatch) {
        var tag = BRAND_TAG_PREFIX + tagMatch[1];
        var tags = currentBrandTags().slice();
        if (tags.indexOf(tag) < 0) tags.push(tag);
        return buildBrandFilterUrl(tags);
      }
    }
    return url;
  }

  function isRemovingFilter(link) {
    if (link.matches('[data-hl-search-clear-all]')) return true;
    if (link.hasAttribute('data-hl-clear-all-filters')) return true;
    if (link.hasAttribute('data-hl-brand-clear-all') || link.closest('.hl-filter-all-brands')) return true;
    if (link.hasAttribute('data-filter-active')) return true;
    if (link.closest('.hl-active-filter-chip__link, .hl-active-filters__clear')) return true;
    if (link.hasAttribute('data-hl-brand-tag')) {
      return currentBrandTags().indexOf(link.getAttribute('data-hl-brand-tag')) >= 0;
    }
    return false;
  }

  function detachOotsFilterHandlers(scope) {
    var $ = window.jQuery;
    if (!$ || !scope) return;
    $(scope).find('a[data-filter-input]').off('click');
  }

  function blockSearchFacetedHandlers() {
    if (!isSearch || !window.facetedFiltering || window.facetedFiltering.__hlSearchNoop) return;
    window.facetedFiltering.__hlSearchNoop = true;
    window.facetedFiltering.init = function () {
      detachOotsFilterHandlers(getRoot() || root);
    };
  }

  function collapseActiveRow(scope) {
    var row = scope.querySelector('.hl-supplements-active-row');
    if (!row) return Promise.resolve();

    row.style.overflow = 'hidden';
    row.style.transition =
      'max-height ' + animMs + 'ms ease, opacity ' + animMs + 'ms ease, margin ' + animMs + 'ms ease';
    row.style.maxHeight = row.scrollHeight + 'px';
    void row.offsetHeight;
    row.style.maxHeight = '0';
    row.style.opacity = '0';
    row.style.marginBottom = '0';

    return new Promise(function (resolve) {
      window.setTimeout(resolve, animMs);
    });
  }

  function animateActiveRowIn(scope) {
    var row = scope.querySelector('.hl-supplements-active-row');
    if (!row) return;
    row.classList.add('hl-supplements-active-row--mount');
    row.addEventListener(
      'animationend',
      function () {
        row.classList.remove('hl-supplements-active-row--mount');
        row.style.removeProperty('overflow');
        row.style.removeProperty('max-height');
        row.style.removeProperty('opacity');
        row.style.removeProperty('margin-bottom');
        row.style.removeProperty('transition');
      },
      { once: true }
    );
  }

  var CATALOG_GIFTS_TAG = 'Gifts';
  var CATALOG_TYPE_TAGS = ['Services', 'Grocery', 'Gifts'];
  var SUPPLEMENTS_COLLECTION = '/collections/nutritional-supplements';

  function catalogFilterState(search) {
    var params = new URLSearchParams(search || window.location.search);
    var activeCatalogTags = params.getAll('filter.p.tag').filter(function (tag) {
      return CATALOG_TYPE_TAGS.indexOf(tag) >= 0;
    });
    var gifts = activeCatalogTags.indexOf(CATALOG_GIFTS_TAG) >= 0;
    var hideBrand =
      activeCatalogTags.indexOf('Services') >= 0 ||
      activeCatalogTags.indexOf('Grocery') >= 0 ||
      gifts;
    return { showBrand: !hideBrand, gifts: gifts };
  }

  function setCatalogFilterGate(el, show) {
    if (!el) return;
    el.hidden = !show;
    el.classList.toggle('hl-catalog-filter-gate--hidden', !show);
    el.style.display = show ? '' : 'none';
  }

  function syncCatalogFilterGates(scope, search) {
    var searchRoot = scope || getRoot() || document;
    if (isSearch) {
      var params = new URLSearchParams(search || window.location.search);
      var activeCatalogTags = params.getAll('filter.p.tag').filter(function (tag) {
        return CATALOG_TYPE_TAGS.indexOf(tag) >= 0;
      });
      var gifts = activeCatalogTags.indexOf(CATALOG_GIFTS_TAG) >= 0;
      var typeParam = params.get('type') || '';
      var articles =
        typeParam === 'article' || (typeParam.indexOf('article') >= 0 && typeParam.indexOf('product') < 0);
      var showBrand =
        !articles &&
        activeCatalogTags.indexOf('Services') < 0 &&
        activeCatalogTags.indexOf('Grocery') < 0 &&
        !gifts;
      searchRoot.querySelectorAll('[data-hl-brand-filter-gate], [data-hl-brand-filter]').forEach(function (el) {
        setCatalogFilterGate(el, showBrand);
      });
      searchRoot.querySelectorAll('[data-hl-benefit-filter-gate]').forEach(function (el) {
        setCatalogFilterGate(el, !gifts && !articles);
      });
      return;
    }
    var path = window.location.pathname;
    if (path !== '/collections/all' && path !== SUPPLEMENTS_COLLECTION) return;
    var searchRoot = scope || getRoot() || document;
    var state = catalogFilterState(search);
    searchRoot.querySelectorAll('[data-hl-brand-filter-gate]').forEach(function (el) {
      setCatalogFilterGate(el, state.showBrand);
    });
    searchRoot.querySelectorAll('[data-hl-brand-filter]').forEach(function (el) {
      if (path === '/collections/all') setCatalogFilterGate(el, state.showBrand);
    });
    searchRoot.querySelectorAll('[data-hl-benefit-filter-gate]').forEach(function (el) {
      setCatalogFilterGate(el, !state.gifts);
    });
  }

  function catalogTypeNavUrl(link) {
    if (!link.closest('[data-hl-catalog-type-filter]')) return null;
    var url = link.dataset.url || link.getAttribute('href');
    if (!url) return null;

    if (link.hasAttribute('data-hl-clear-catalog-types')) {
      var clearUrl = new URL('/collections/all', window.location.origin);
      var current = new URL(window.location.href);
      if (current.searchParams.get('sort_by')) {
        clearUrl.searchParams.set('sort_by', current.searchParams.get('sort_by'));
      }
      return clearUrl.pathname + clearUrl.search;
    }

    return url;
  }

  function syncFilterPanels(scope) {
    scope.querySelectorAll('.hl-sidebar-filters [data-filter-group]').forEach(function (group) {
      var heading = group.querySelector('.sidebar__block-heading.toggle');
      var panel = group.querySelector('[data-filter-group-list], ul.toggle_list');
      var toggle = heading && heading.querySelector('span');
      if (!heading || !panel || !toggle) return;

      var open =
        group.hasAttribute('data-hl-catalog-type-filter') ||
        !!(
          group.querySelector('[data-filter-active]') ||
          group.querySelector(
            '.faceted-filters__filter-link--active:not(.hl-filter-all-brands .faceted-filters__filter-link--active)'
          )
        );
      panel.style.display = open ? 'block' : 'none';
      toggle.textContent = open ? '\u2212' : '+';
      heading.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function isSupplementsOnlyOnAll(search) {
    if (window.location.pathname !== '/collections/all') return false;
    var params = new URLSearchParams(search || window.location.search);
    var hasCatalogTag = params.getAll('filter.p.tag').some(function (tag) {
      return CATALOG_TYPE_TAGS.indexOf(tag) >= 0;
    });
    if (hasCatalogTag) return false;
    return (
      params.get('filter.p.product_type') === 'Supplements' ||
      params.getAll('filter.p.product_type').indexOf('Supplements') >= 0
    );
  }

  function fetchSupplementsGridSection(search) {
    var nutrUrl = new URL(SUPPLEMENTS_COLLECTION, window.location.origin);
    var params = new URLSearchParams(search || window.location.search);
    params.delete('filter.p.product_type');
    nutrUrl.search = params.toString();
    return fetchSection(nutrUrl.pathname + nutrUrl.search);
  }

  function rewriteAllSupplementsLinks(scope, targetSearch) {
    if (!scope) return;
    scope.querySelectorAll('a[href*="/collections/nutritional-supplements"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      try {
        var src = new URL(href, window.location.origin);
        /* Grid thumbnails use product.url | within: collection — do not rewrite PDP links. */
        if (src.pathname.indexOf('/products/') >= 0) return;
        var all = new URL('/collections/all', window.location.origin);
        var target = new URLSearchParams(targetSearch || window.location.search);
        all.searchParams.set('filter.p.product_type', 'Supplements');
        if (target.get('sort_by')) all.searchParams.set('sort_by', target.get('sort_by'));
        if (src.searchParams.get('page')) all.searchParams.set('page', src.searchParams.get('page'));
        var next = all.pathname + all.search;
        link.setAttribute('href', next);
        if (link.dataset.url) link.dataset.url = next;
      } catch (_err) {
        /* ignore malformed href */
      }
    });
  }

  function hasSupplementsTypeFilter(search) {
    var params = new URLSearchParams(search || window.location.search);
    return (
      params.get('filter.p.product_type') === 'Supplements' ||
      params.getAll('filter.p.product_type').indexOf('Supplements') >= 0
    );
  }

  function supplementsTypeClearUrl(search) {
    var url = new URL('/collections/all', window.location.origin);
    var params = new URLSearchParams(search || window.location.search);
    if (params.get('sort_by')) {
      url.searchParams.set('sort_by', params.get('sort_by'));
    }
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 && key !== 'filter.p.product_type') {
        url.searchParams.append(key, value);
      }
    });
    return url.pathname + url.search;
  }

  function setCatalogTypeHeadingCount(heading, count) {
    if (!heading) return;
    var label = 'Filter by Type' + (count > 0 ? ' (' + count + ')' : '');
    var updated = false;
    heading.childNodes.forEach(function (node) {
      if (node.nodeType === 3) {
        node.textContent = label;
        updated = true;
      }
    });
    if (!updated) heading.appendChild(document.createTextNode(label));
  }

  function syncSupplementsTypeActive(search) {
    if (window.location.pathname !== '/collections/all') return;
    var hasSupplementsType = hasSupplementsTypeFilter(search);

    document.querySelectorAll('[data-hl-catalog-type-filter]').forEach(function (group) {
      var heading = group.querySelector('.sidebar__block-heading.toggle');
      var panel = group.querySelector('[data-filter-group-list]');
      var toggle = heading && heading.querySelector('span');

      group.querySelectorAll('[data-handle="filter-catalog-supplements"]').forEach(function (checkbox) {
        var link = checkbox.closest('a');
        var li = link && link.closest('li');
        if (!link) return;
        if (!hasSupplementsType) {
          checkbox.removeAttribute('data-filter-checked');
          link.classList.remove('sidebar__tag-link--active', 'faceted-filters__filter-link--active');
          link.removeAttribute('data-filter-active');
          if (li) li.classList.remove('sidebar__block-link--active');
          return;
        }

        var removeUrl = supplementsTypeClearUrl(search);
        checkbox.setAttribute('data-filter-checked', '');
        link.classList.add('sidebar__tag-link--active', 'faceted-filters__filter-link--active');
        link.setAttribute('data-filter-active', '');
        link.setAttribute('data-url', removeUrl);
        link.setAttribute('href', removeUrl);
        if (li) li.classList.add('sidebar__block-link--active');
      });

      if (!hasSupplementsType) return;

      group.querySelectorAll('.hl-filter-all-types a').forEach(function (link) {
        link.classList.remove('sidebar__tag-link--active', 'faceted-filters__filter-link--active');
        link.removeAttribute('data-filter-active');
      });
      group.querySelectorAll('.hl-filter-all-types').forEach(function (li) {
        li.classList.remove('sidebar__block-link--active');
      });

      if (heading && panel && toggle) {
        panel.style.display = 'block';
        toggle.textContent = '\u2212';
        heading.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-expanded', 'true');
        setCatalogTypeHeadingCount(heading, 1);
      }
    });
  }

  function syncSupplementsActiveFilterRow(search) {
    if (window.location.pathname !== '/collections/all') return;
    if (!hasSupplementsTypeFilter(search)) return;

    var root = getRoot();
    if (!root) return;
    var container = root.querySelector('.has-sidebar-option > .container');
    if (!container) return;

    var row = container.querySelector('.hl-supplements-active-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'hl-supplements-active-row collection-filter-active-tags';
      var toolbar = container.querySelector('.hl-supplements-toolbar-row');
      if (toolbar && toolbar.parentNode) {
        toolbar.parentNode.insertBefore(row, toolbar.nextSibling);
      } else {
        container.insertBefore(row, container.firstChild);
      }
      row.innerHTML =
        '<div class="faceted-page__filters--active hl-active-filters hl-active-filters--inline">' +
        '<ul class="active-filter-group hl-active-filters__list"></ul></div>';
    }

    var list = row.querySelector('.hl-active-filters__list');
    if (!list) return;

    if (!list.querySelector('[data-hl-supplements-type-chip]')) {
      var clearUrl = supplementsTypeClearUrl(search);
      var li = document.createElement('li');
      li.className = 'active-filter-group__item-wrapper hl-active-filter-chip';
      li.innerHTML =
        '<a class="active-filter-group__item hl-active-filter-chip__link" data-hl-supplements-type-chip ' +
        'data-url="' +
        clearUrl +
        '" href="' +
        clearUrl +
        '" aria-label="Remove filter: Supplements">' +
        '<span class="active-filter-text hl-active-filter-chip__text">Supplements</span>' +
        '<span class="hl-active-filter-chip__remove" aria-hidden="true"></span></a>';
      list.insertBefore(li, list.firstChild);
    }

    if (!list.querySelector('.hl-active-filters__clear') && list.querySelectorAll('.hl-active-filter-chip').length) {
      var allClear = new URL('/collections/all', window.location.origin);
      var params = new URLSearchParams(search || window.location.search);
      if (params.get('sort_by')) allClear.searchParams.set('sort_by', params.get('sort_by'));
      var clearAllUrl = allClear.pathname + allClear.search;
      var clearLi = document.createElement('li');
      clearLi.className = 'active-filter-group__item-wrapper hl-active-filters__clear-wrap';
      clearLi.innerHTML =
        '<a class="active-filter-group__clear-all hl-active-filters__clear" href="' +
        clearAllUrl +
        '">Clear all</a>';
      list.appendChild(clearLi);
    }
  }

  function ensureClearAllInList(list, clearUrl) {
    if (!list || list.querySelector('.hl-active-filters__clear')) return;
    if (!list.querySelector('.hl-active-filter-chip')) return;
    var clearLi = document.createElement('li');
    clearLi.className = 'active-filter-group__item-wrapper hl-active-filters__clear-wrap';
    clearLi.innerHTML =
      '<a class="active-filter-group__clear-all hl-active-filters__clear" href="' +
      clearUrl +
      '" data-url="' +
      clearUrl +
      '" data-hl-clear-all-filters>Clear all</a>';
    list.appendChild(clearLi);
  }

  function collectionHasFilterParams(search) {
    var params = new URLSearchParams((search || window.location.search).replace(/^\?/, ''));
    var has = false;
    params.forEach(function (_value, key) {
      if (key.indexOf('filter.p.') === 0) has = true;
    });
    return has;
  }

  function collectionRemoveParamUrl(param, value, search) {
    var url = new URL(window.location.pathname + (search || window.location.search), window.location.origin);
    var kept = url.searchParams.getAll(param).filter(function (v) {
      return v !== value;
    });
    url.searchParams.delete(param);
    kept.forEach(function (v) {
      url.searchParams.append(param, v);
    });
    return url.pathname + url.search;
  }

  function brandLabelFromSidebar(tag) {
    var slug = tag.replace(/^hl-brand-/, '');
    var links = document.querySelectorAll('[data-hl-brand-filter] a[data-hl-brand-tag="' + tag + '"]');
    if (links.length) {
      var text = links[0].querySelector('.' + 'faceted-filters__filter-list-item-text');
      if (text) return text.textContent.replace(/\(\d+\)\s*$/, '').trim();
    }
    links = document.querySelectorAll('[data-hl-brand-filter] a[data-filter-active]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (href.indexOf(tag) >= 0) {
        var labelEl = links[i].querySelector('.' + 'faceted-filters__filter-list-item-text');
        if (labelEl) return labelEl.textContent.replace(/\(\d+\)\s*$/, '').trim();
      }
    }
    return slug.replace(/_/g, ' ').replace(/-/g, ' ');
  }

  function ensureCollectionActiveFilterRow(search) {
    if (isSearch || window.location.pathname === '/collections/all') return;
    if (!collectionHasFilterParams(search)) return;
    var root = getRoot();
    var container = root && root.querySelector('.has-sidebar-option > .container');
    if (!container) return;

    var row = container.querySelector('.hl-supplements-active-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'hl-supplements-active-row collection-filter-active-tags';
      var quote = container.querySelector('p.quote');
      var toolbar = container.querySelector('.hl-supplements-toolbar-row');
      if (toolbar) container.insertBefore(row, toolbar.nextSibling);
      else if (quote) container.insertBefore(row, quote);
      else container.insertBefore(row, container.firstChild);
      row.innerHTML =
        '<div class="faceted-page__filters--active hl-active-filters hl-active-filters--inline">' +
        '<ul class="active-filter-group hl-active-filters__list"></ul></div>';
    }

    var list = row.querySelector('.hl-active-filters__list');
    if (!list) return;

    var params = new URLSearchParams((search || window.location.search).replace(/^\?/, ''));
    var clearUrl = clearAllFiltersUrl();

    if (!list.querySelector('.hl-active-filter-chip')) {
      params.getAll('filter.p.tag').forEach(function (tag) {
        var label = tag.indexOf('hl-brand-') === 0 ? brandLabelFromSidebar(tag) : tag;
        var removeUrl = collectionRemoveParamUrl('filter.p.tag', tag, search);
        var li = document.createElement('li');
        li.className = 'active-filter-group__item-wrapper hl-active-filter-chip';
        li.innerHTML =
          '<a class="active-filter-group__item hl-active-filter-chip__link" href="' +
          removeUrl +
          '" data-url="' +
          removeUrl +
          '" aria-label="Remove filter: ' +
          label.replace(/"/g, '&quot;') +
          '"><span class="active-filter-text hl-active-filter-chip__text">' +
          label +
          '</span><span class="hl-active-filter-chip__remove" aria-hidden="true"></span></a>';
        list.appendChild(li);
      });
    }

    ensureClearAllInList(list, clearUrl);
  }

  function syncFilterUi(search) {
    if (!isSearch) {
      syncSupplementsTypeActive(search);
      syncSupplementsActiveFilterRow(search);
      ensureCollectionActiveFilterRow(search);
    }
    var scope = getRoot();
    if (scope) syncFilterPanels(scope);
    document.querySelectorAll('.hl-filter-dropdown__filters').forEach(function (panel) {
      syncFilterPanels(panel);
    });
    document.querySelectorAll('.faceted-filter-modal .hl-sidebar-filters').forEach(function (panel) {
      syncFilterPanels(panel);
    });
    syncCatalogFilterGates(document, search);
  }
  window.hlSyncSupplementsFilterUi = syncFilterUi;
  window.hlSyncSearchFilterUi = syncFilterUi;

  function patchSupplementsGridOnAll(nutrSectionHtml, targetSearch) {
    if (!nutrSectionHtml) return;
    var tpl = document.createElement('div');
    tpl.innerHTML = nutrSectionHtml;
    var srcContainer = tpl.querySelector('.has-sidebar-option > .container');
    var root = getRoot();
    var dstContainer = root && root.querySelector('.has-sidebar-option > .container');
    if (!srcContainer || !dstContainer) return;

    dstContainer.querySelectorAll('.thumbnail.column, .thumbnail.hl-supplements-card').forEach(function (el) {
      el.remove();
    });
    var paginateWrap = dstContainer.querySelector('.paginate');
    if (paginateWrap) {
      var paginateCol = paginateWrap.closest('.one-whole.column, .column.one-whole');
      if (paginateCol) paginateCol.remove();
    }
    var noMatches = dstContainer.querySelector('p.quote');
    if (noMatches) noMatches.remove();

    srcContainer.querySelectorAll('.thumbnail.column, .thumbnail.hl-supplements-card').forEach(function (thumb) {
      dstContainer.appendChild(document.importNode(thumb, true));
    });
    var srcPaginate = srcContainer.querySelector('.paginate');
    if (srcPaginate) {
      var srcPaginateCol = srcPaginate.closest('.one-whole.column, .column.one-whole');
      if (srcPaginateCol) dstContainer.appendChild(document.importNode(srcPaginateCol, true));
    }

    rewriteAllSupplementsLinks(dstContainer, targetSearch);
    if (root) detachOotsFilterHandlers(root);
  }

  function maybePatchSupplementsGridOnAll(targetSearch) {
    if (!isSupplementsOnlyOnAll(targetSearch)) return Promise.resolve();
    return fetchSupplementsGridSection(targetSearch).then(function (data) {
      patchSupplementsGridOnAll(data[sectionId], targetSearch);
      syncFilterUi(targetSearch);
      syncCatalogFilterGates(document, targetSearch);
    });
  }

  function getSearchPendingEl(scope) {
    return (scope && scope.querySelector('.has-sidebar-option > .container')) || scope;
  }

  function removeSearchGridNodes(container) {
    if (!container) return;
    container.querySelectorAll(
      '.thumbnail.column, .thumbnail.hl-supplements-card, .hl-search-results__articles, p.quote, .hl-supplements-active-row, [data-hl-search-active-filters]'
    ).forEach(function (el) {
      el.remove();
    });
    var paginateWrap = container.querySelector('.paginate');
    if (paginateWrap) {
      var paginateCol = paginateWrap.closest('.one-whole.column, .column.one-whole');
      if (paginateCol) paginateCol.remove();
    }
  }

  function patchSearchFilterPanels(srcSwap, dstSwap) {
    if (!srcSwap || !dstSwap) return;
    var srcSidebarFilters = srcSwap.querySelector('.sidebar .hl-sidebar-filters');
    var dstSidebarFilters = dstSwap.querySelector('.sidebar .hl-sidebar-filters');
    if (srcSidebarFilters && dstSidebarFilters) {
      dstSidebarFilters.innerHTML = srcSidebarFilters.innerHTML;
    }
    var srcMobileFilters = srcSwap.querySelector('.hl-filter-dropdown__filters');
    var dstMobileFilters = dstSwap.querySelector('.hl-filter-dropdown__filters');
    if (srcMobileFilters && dstMobileFilters) {
      dstMobileFilters.innerHTML = srcMobileFilters.innerHTML;
    }
  }

  function appendSearchGridNodes(srcContainer, dstContainer) {
    if (!srcContainer || !dstContainer) return;
    Array.from(srcContainer.children).forEach(function (child) {
      if (child.classList.contains('hl-filter-dropdown')) return;
      if (child.classList.contains('hl-supplements-active-row')) return;
      if (child.querySelector && child.querySelector('[data-hl-search-active-filters]')) return;
      dstContainer.appendChild(document.importNode(child, true));
    });
  }

  function finishSearchFilterNav(targetSearch) {
    var nextRoot = getRoot();
    syncCatalogFilterGates(document, targetSearch);
    syncSearchCatalogTypeFromUrl(targetSearch);
    syncSearchBrandFilterFromUrl(targetSearch);
    syncSearchActiveFilterRow(targetSearch);
    applySearchProductFiltersFromUrl(targetSearch);
    if (nextRoot) {
      syncFilterPanels(nextRoot);
      detachOotsFilterHandlers(nextRoot);
      if (window.hlLockApothecaryGridImages) window.hlLockApothecaryGridImages(nextRoot);
    }
    document.querySelectorAll('.hl-filter-dropdown__filters').forEach(function (panel) {
      syncFilterPanels(panel);
    });
    if (window.hlFilterDropdown) {
      window.hlFilterDropdown.sync();
    }
    window.setTimeout(function () {
      scheduleSupplementSearchArticles(targetSearch);
      scheduleSupplementSearchBrandProducts(targetSearch);
    }, 0);
  }

  function searchCatalogTypeAddUrl(type, q) {
    var base = '/search?q=' + encodeURIComponent(q);
    if (type === 'Articles') return base + '&type=article';
    if (type === 'Supplements') return base + '&type=product&filter.p.product_type=Supplements';
    if (CATALOG_TYPE_TAGS.indexOf(type) >= 0) {
      return base + '&type=product&filter.p.tag=' + encodeURIComponent(type);
    }
    return base;
  }

  function optimisticSearchFilterUi(url) {
    if (!isSearch) return;
    var targetUrl = new URL(url, window.location.origin);
    var targetSearch = targetUrl.search;
    history.replaceState({ hlFilter: true }, '', targetUrl.pathname + targetSearch);
    syncSearchCatalogTypeFromUrl(targetSearch);
    syncSearchBrandFilterFromUrl(targetSearch);
    syncSearchActiveFilterRow(targetSearch);
    syncCatalogFilterGates(document, targetSearch);
    applySearchProductFiltersFromUrl(targetSearch);
  }

  function patchSearchFromSection(sectionHtml, targetSearch) {
    var tpl = document.createElement('div');
    tpl.innerHTML = sectionHtml;
    var srcSwap = tpl.querySelector('[data-hl-supplements-swap]');
    var rootEl = getRoot();
    var dstSwap = rootEl && rootEl.querySelector('[data-hl-supplements-swap]');
    if (!srcSwap || !dstSwap) {
      swapSection(sectionHtml, targetSearch);
      return;
    }

    var newCount = tpl.querySelector('.hl-search-results__count');
    var curCount = document.querySelector('.hl-search-results__count');
    if (newCount && curCount) curCount.innerHTML = newCount.innerHTML;

    patchSearchFilterPanels(srcSwap, dstSwap);

    var srcContainer = srcSwap.querySelector('.has-sidebar-option > .container');
    var dstContainer = dstSwap.querySelector('.has-sidebar-option > .container');
    if (!srcContainer || !dstContainer) {
      swapSection(sectionHtml, targetSearch);
      return;
    }

    removeSearchGridNodes(dstContainer);
    appendSearchGridNodes(srcContainer, dstContainer);
    finishSearchFilterNav(targetSearch);
  }

  function applySearchSectionHtml(sectionHtml, targetSearch) {
    try {
      patchSearchFromSection(sectionHtml, targetSearch);
    } catch (err) {
      swapSection(sectionHtml, targetSearch);
    }
  }

  function fetchSection(url, opts) {
    opts = opts || {};
    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('sections', sectionId);
    var controller = new AbortController();
    if (opts.kind === 'supplement' || opts.kind === 'warm') {
      if (sectionFetchAborters[opts.kind]) sectionFetchAborters[opts.kind].abort();
      sectionFetchAborters[opts.kind] = controller;
    }
    var fetchOpts = {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
    };
    if (opts.kind) fetchOpts.signal = controller.signal;
    return fetch(fetchUrl.pathname + fetchUrl.search, fetchOpts)
      .then(function (response) {
        if (!response.ok) throw new Error('section fetch failed');
        return response.json();
      })
      .finally(function () {
        if (opts.kind && sectionFetchAborters[opts.kind] === controller) {
          sectionFetchAborters[opts.kind] = null;
        }
      });
  }

  function warmSearchSectionFetch() {
    if (!isSearch) return;
    var path = window.location.pathname + window.location.search;
    fetchSection(path, { kind: 'warm' }).catch(function (err) {
      if (!isAbortError(err)) return;
    });
  }

  function swapSection(sectionHtml, targetSearch) {
    var tpl = document.createElement('div');
    tpl.innerHTML = sectionHtml;
    var newSwap = tpl.querySelector('[data-hl-supplements-swap]');
    var currentSwap = getRoot() && getRoot().querySelector('[data-hl-supplements-swap]');
    if (!newSwap || !currentSwap) throw new Error('swap target missing');

    if (isSearch) {
      var newCount = tpl.querySelector('.hl-search-results__count');
      var curCount = document.querySelector('.hl-search-results__count');
      if (newCount && curCount) curCount.innerHTML = newCount.innerHTML;
    }

    var scrollY = window.scrollY;
    currentSwap.replaceWith(document.importNode(newSwap, true));

    var nextRoot = getRoot();
    if (nextRoot) {
      syncFilterUi(targetSearch);
      animateActiveRowIn(nextRoot);
    }

    if (window.hlFilterDropdown) {
      window.hlFilterDropdown.closeAll();
      window.hlFilterDropdown.sync();
    }

    window.scrollTo(0, scrollY);
    if (window.hlLockApothecaryGridImages) window.hlLockApothecaryGridImages(nextRoot || document);

    if (window.facetedFiltering && typeof window.facetedFiltering.init === 'function' && !isSearch) {
      window.facetedFiltering.init();
    }
    syncCatalogFilterGates(document, targetSearch);
    syncFilterUi(targetSearch);
    if (nextRoot) detachOotsFilterHandlers(nextRoot);
    if (isSearch) {
      finishSearchFilterNav(targetSearch);
    }
  }

  function closeFilterModal() {
    var $ = window.jQuery;
    if ($ && $.fancybox && $.fancybox.getInstance()) {
      $.fancybox.close();
    }
  }

  function navigate(url, opts) {
    if (pending || !url) return;
    if (isSearch) url = normalizeSearchNavUrl(url);
    if (isSearch && url.indexOf('/search') !== 0) return;
    if (!isSearch && url.indexOf('/collections') !== 0) return;
    pending = true;

    var scope = getRoot();
    var pendingEl = isSearch ? getSearchPendingEl(scope) : scope;
    if (pendingEl) pendingEl.classList.add('hl-filter-pending');

    var work =
      !isSearch && opts && opts.collapseFirst && scope
        ? collapseActiveRow(scope)
        : Promise.resolve();

    work
      .then(function () {
        if (isSearch) abortBackgroundSectionFetches();
        return fetchSection(url);
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) throw new Error('empty section response');
        var targetSearch = new URL(url, window.location.origin).search;
        history.pushState({ hlFilter: true }, '', url);
        if (isSearch) {
          applySearchSectionHtml(html, targetSearch);
        } else {
          swapSection(html, targetSearch);
        }
        syncCatalogFilterGates(document, targetSearch);
        if (isSearch) return;
        return maybePatchSupplementsGridOnAll(targetSearch);
      })
      .then(function () {
        closeFilterModal();
        if (window.hlFilterDropdown) {
          window.hlFilterDropdown.closeAll();
        }
      })
      .catch(function (err) {
        if (isAbortError(err)) return;
        if (isSearch) {
          var targetSearch = new URL(url, window.location.origin).search;
          applySearchProductFiltersFromUrl(targetSearch);
          finishSearchFilterNav(targetSearch);
          return;
        }
        window.location.assign(url);
      })
      .finally(function () {
        pending = false;
        var next = getRoot();
        var clearEl = isSearch ? getSearchPendingEl(next) : next;
        if (clearEl) clearEl.classList.remove('hl-filter-pending');
      });
  }

  function onFilterLinkActivate(e) {
    var link = filterNavLink(e.target.closest('a'));
    if (!link) return;

    var url = navUrl(link);
    if (!url) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (isSearch) detachOotsFilterHandlers(getRoot());
    optimisticSearchFilterUi(url);
    navigate(url, { collapseFirst: !isSearch && isRemovingFilter(link) });
  }

  document.addEventListener('click', onFilterLinkActivate, true);

  window.addEventListener('popstate', function () {
    if (pending) return;
    navigate(window.location.pathname + window.location.search, {});
  });

  function searchClearUrlFromParams(params) {
    var q = params.get('q');
    return q ? '/search?q=' + encodeURIComponent(q) : '/search';
  }

  function searchRemoveParamUrl(key, value, searchSource) {
    var url = new URL(window.location.href);
    if (searchSource) {
      var qs = searchFilterParamsFromSource(searchSource);
      url = new URL(url.pathname + '?' + qs.toString(), window.location.origin);
    }
    var kept = url.searchParams.getAll(key).filter(function (v) {
      return v !== value;
    });
    url.searchParams.delete(key);
    kept.forEach(function (v) {
      url.searchParams.append(key, v);
    });
    return url.pathname + url.search;
  }

  function searchHasFilterParams(search) {
    var params = searchFilterParamsFromSource(search);
    var type = params.get('type') || '';
    if (type === 'article' || (type.indexOf('article') >= 0 && type.indexOf('product') < 0)) return true;
    var has = false;
    params.forEach(function (_, key) {
      if (key.indexOf('filter.p.') === 0) has = true;
    });
    return has;
  }

  function syncSearchActiveFilterRow(searchSource) {
    if (!isSearch) return;
    var root = getRoot();
    var container = root && root.querySelector('.has-sidebar-option > .container');
    if (!container) return;

    container.querySelectorAll('.hl-supplements-active-row').forEach(function (row) {
      row.remove();
    });

    ensureSearchActiveFilterRow(searchSource);
  }
  window.hlSyncSearchActiveFilterRow = syncSearchActiveFilterRow;

  function ensureSearchActiveFilterRow(searchSource) {
    if (!isSearch || !searchHasFilterParams(searchSource)) return;
    var root = getRoot();
    var container = root && root.querySelector('.has-sidebar-option > .container');
    if (!container) return;

    var params = searchFilterParamsFromSource(searchSource);
    var clearUrl = searchClearUrlFromParams(params);
    var chips = [];
    var seen = new Set();
    var catalogTags = ['Services', 'Grocery', 'Gifts'];

    function addChip(label, removeUrl, isTypeChip) {
      if (!label || seen.has(label)) return;
      seen.add(label);
      chips.push(
        '<li class="active-filter-group__item-wrapper hl-active-filter-chip">' +
          '<a class="active-filter-group__item hl-active-filter-chip__link"' +
          (isTypeChip ? ' data-hl-search-type-chip' : '') +
          ' href="' +
          removeUrl +
          '" data-url="' +
          removeUrl +
          '" aria-label="Remove filter: ' +
          label.replace(/"/g, '&quot;') +
          '">' +
          '<span class="active-filter-text hl-active-filter-chip__text">' +
          label +
          '</span>' +
          '<span class="hl-active-filter-chip__remove" aria-hidden="true"></span></a></li>'
      );
    }

    var type = params.get('type') || '';
    if (type === 'article' || (type.indexOf('article') >= 0 && type.indexOf('product') < 0)) {
      addChip('Articles', clearUrl, true);
    }

    params.getAll('filter.p.product_type').forEach(function (val) {
      addChip(val, searchRemoveParamUrl('filter.p.product_type', val, searchSource), val === 'Supplements');
    });

    params.getAll('filter.p.tag').forEach(function (tag) {
      var label = tag;
      if (isBrandTag(tag)) {
        label = brandLabelFromSidebar(tag);
      } else if (tag.indexOf('hl-brand-') === 0) {
        label = tag.replace('hl-brand-', '').replace(/-/g, ' ');
      }
      addChip(label, searchRemoveParamUrl('filter.p.tag', tag, searchSource), catalogTags.indexOf(tag) >= 0);
    });

    if (!chips.length) return;

    chips.push(
      '<li class="active-filter-group__item-wrapper hl-active-filters__clear-wrap">' +
        '<a class="active-filter-group__clear-all hl-active-filters__clear" href="' +
        clearUrl +
        '" data-hl-search-clear-all>Clear all</a></li>'
    );

    var row = document.createElement('div');
    row.className = 'hl-supplements-active-row collection-filter-active-tags';
    row.setAttribute('data-hl-search-active-filters-fallback', '');
    row.innerHTML =
      '<div class="faceted-page__filters--active hl-active-filters hl-active-filters--inline">' +
      '<ul class="active-filter-group hl-active-filters__list" data-hl-search-active-filter-list">' +
      chips.join('') +
      '</ul></div>';

    var dropdown = container.querySelector('.hl-filter-dropdown');
    if (dropdown && dropdown.parentNode) {
      dropdown.parentNode.insertBefore(row, dropdown.nextSibling);
    } else {
      container.insertBefore(row, container.firstChild);
    }
    detachOotsFilterHandlers(root);
  }
  window.hlEnsureSearchActiveFilterRow = ensureSearchActiveFilterRow;

  function syncSearchCatalogTypeFromUrl(searchSource) {
    if (!isSearch) return;
    var params = searchFilterParamsFromSource(searchSource);
    var q = params.get('q');
    if (!q) return;
    var clearUrl = '/search?q=' + encodeURIComponent(q);
    var catalogTag = '';
    params.getAll('filter.p.tag').forEach(function (tag) {
      if (['Services', 'Grocery', 'Gifts'].indexOf(tag) >= 0) catalogTag = tag;
    });
    var articles =
      params.get('type') === 'article' ||
      ((params.get('type') || '').indexOf('article') >= 0 && (params.get('type') || '').indexOf('product') < 0);
    var supplements = params.getAll('filter.p.product_type').indexOf('Supplements') >= 0;
    var anyType = articles || supplements || !!catalogTag;

    document.querySelectorAll('[data-hl-catalog-type-filter]').forEach(function (group) {
      var allLink = group.querySelector('.hl-filter-all-types a');
      if (allLink) {
        allLink.classList.toggle('sidebar__tag-link--active', !anyType);
        allLink.classList.toggle('faceted-filters__filter-link--active', !anyType);
        allLink.closest('.hl-filter-all-types').classList.toggle('sidebar__block-link--active', !anyType);
        allLink.setAttribute('href', clearUrl);
        allLink.setAttribute('data-url', clearUrl);
        if (!anyType) allLink.setAttribute('data-filter-active', '');
        else allLink.removeAttribute('data-filter-active');
      }

      group.querySelectorAll('[data-hl-catalog-type]').forEach(function (link) {
        var type = link.getAttribute('data-hl-catalog-type');
        var active =
          (type === 'Articles' && articles) ||
          (type === 'Supplements' && supplements) ||
          type === catalogTag;
        var li = link.closest('li');
        link.classList.toggle('sidebar__tag-link--active', active);
        link.classList.toggle('faceted-filters__filter-link--active', active);
        if (li) li.classList.toggle('sidebar__block-link--active', active);
        var checkbox = link.querySelector('[data-filter-checkbox]');
        if (checkbox) {
          if (active) checkbox.setAttribute('data-filter-checked', '');
          else checkbox.removeAttribute('data-filter-checked');
        }
        if (active) {
          link.setAttribute('data-filter-active', '');
          link.setAttribute('href', clearUrl);
          link.setAttribute('data-url', clearUrl);
        } else {
          link.removeAttribute('data-filter-active');
          var addUrl = searchCatalogTypeAddUrl(type, q);
          link.setAttribute('href', addUrl);
          link.setAttribute('data-url', addUrl);
        }
      });
    });
  }
  window.hlSyncSearchCatalogTypeFromUrl = syncSearchCatalogTypeFromUrl;

  function syncSearchBrandFilterFromUrl(searchSource) {
    if (!isSearch) return;
    var params = searchFilterParamsFromSource(searchSource);
    var activeBrandTags = params.getAll('filter.p.tag').filter(isBrandTag);
    var anyBrand = activeBrandTags.length > 0;
    var q = params.get('q');
    var clearUrl = q ? '/search?q=' + encodeURIComponent(q) : '/search';

    document.querySelectorAll('[data-hl-brand-filter]').forEach(function (group) {
      var allLink = group.querySelector('.hl-filter-all-brands a');
      if (allLink) {
        var allActive = !anyBrand;
        allLink.classList.toggle('sidebar__tag-link--active', allActive);
        allLink.classList.toggle('faceted-filters__filter-link--active', allActive);
        allLink.closest('.hl-filter-all-brands').classList.toggle('sidebar__block-link--active', allActive);
        allLink.setAttribute('href', clearUrl);
        allLink.setAttribute('data-url', clearUrl);
        if (allActive) allLink.setAttribute('data-filter-active', '');
        else allLink.removeAttribute('data-filter-active');
      }

      group.querySelectorAll('a[data-filter-input]').forEach(function (link) {
        if (link.hasAttribute('data-hl-brand-clear-all')) return;
        var brandTag = brandTagFromFilterLink(link);
        var active = brandTag && activeBrandTags.indexOf(brandTag) >= 0;
        var li = link.closest('li');
        link.classList.toggle('sidebar__tag-link--active', active);
        link.classList.toggle('faceted-filters__filter-link--active', active);
        if (li) li.classList.toggle('sidebar__block-link--active', active);
        var checkbox = link.querySelector('[data-filter-checkbox]');
        if (checkbox) {
          if (active) checkbox.setAttribute('data-filter-checked', '');
          else checkbox.removeAttribute('data-filter-checked');
        }
        if (active) {
          link.setAttribute('data-filter-active', '');
          link.setAttribute('href', clearUrl);
          link.setAttribute('data-url', clearUrl);
        } else {
          link.removeAttribute('data-filter-active');
        }
      });
    });
  }
  window.hlSyncSearchBrandFilterFromUrl = syncSearchBrandFilterFromUrl;

  function shouldSupplementSearchArticles(searchSource) {
    if (!isSearch || !document.querySelector('[data-hl-search-articles-supplement]')) return false;
    var params = searchFilterParamsFromSource(searchSource);
    if (!params.get('q')) return false;
    var type = params.get('type') || '';
    if (type === 'article' || (type.indexOf('article') >= 0 && type.indexOf('product') < 0)) return false;
    if (type === 'product') return false;
    var blocked = false;
    params.forEach(function (_, key) {
      if (key.indexOf('filter.p.') === 0) blocked = true;
    });
    return !blocked;
  }

  function supplementSearchArticles(searchSource) {
    var mount = document.querySelector('[data-hl-search-articles-supplement]');
    if (!mount || !shouldSupplementSearchArticles(searchSource)) return Promise.resolve();
    var q = searchFilterParamsFromSource(searchSource).get('q');
    if (!q) return Promise.resolve();

    mount.querySelectorAll('[data-hl-search-article-supplement]').forEach(function (node) {
      node.remove();
    });

    return fetchSection('/search?q=' + encodeURIComponent(q) + '&type=article', { kind: 'supplement' })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var rows = tpl.querySelectorAll('[data-hl-search-article-row]');
        if (!rows.length) return;
        var seen = new Set();
        mount.querySelectorAll('a[href*="/blogs/"]').forEach(function (a) {
          seen.add((a.getAttribute('href') || '').split('?')[0]);
        });
        var frag = document.createDocumentFragment();
        rows.forEach(function (row) {
          var a = row.querySelector('a[href*="/blogs/"]');
          if (!a) return;
          var href = (a.getAttribute('href') || '').split('?')[0];
          if (seen.has(href)) return;
          var clone = document.importNode(row, true);
          clone.setAttribute('data-hl-search-article-supplement', '');
          frag.appendChild(clone);
        });
        if (frag.childNodes.length) mount.insertBefore(frag, mount.firstChild);
      })
      .catch(function (err) {
        if (isAbortError(err)) return;
      });
  }
  window.hlSupplementSearchArticles = supplementSearchArticles;

  function scheduleSupplementSearchArticles(searchSource) {
    if (!shouldSupplementSearchArticles(searchSource)) return;
    var run = function () {
      supplementSearchArticles(searchSource);
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 3000 });
    } else {
      window.setTimeout(run, 2000);
    }
  }
  window.hlScheduleSupplementSearchArticles = scheduleSupplementSearchArticles;

  function normalizeBrandQuery(q) {
    return (q || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function resolveBrandCollectionForSearchQuery(q) {
    var brands = window.hlSupplementsBrands;
    if (!brands || !brands.length || !q) return null;
    var nq = normalizeBrandQuery(q);
    if (!nq) return null;
    for (var i = 0; i < brands.length; i++) {
      var brand = brands[i];
      var vendor = normalizeBrandQuery(brand.vendor || '');
      var slug = (brand.handle || '').replace(/^supplements-brand-/, '').replace(/-/g, ' ');
      var filterTag = normalizeBrandQuery(brand.filter_tag || '');
      if (nq === vendor || nq === slug || nq === filterTag) return brand;
      if (vendor && (vendor.indexOf(nq) >= 0 || nq.indexOf(vendor) >= 0)) return brand;
      if (slug && (slug.indexOf(nq) >= 0 || nq.indexOf(slug) >= 0)) return brand;
    }
    return null;
  }

  function shouldSupplementSearchBrandProducts(searchSource) {
    if (!isSearch || !document.querySelector('[data-hl-search-brand-supplement-mount]')) return false;
    var params = searchFilterParamsFromSource(searchSource);
    if (!params.get('q')) return false;
    var type = params.get('type') || '';
    if (type === 'article' || (type.indexOf('article') >= 0 && type.indexOf('product') < 0)) return false;
    return !!resolveBrandCollectionForSearchQuery(params.get('q'));
  }

  function productHandleFromCard(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var match = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function removeSearchBrandProductSupplements(scope) {
    var root = scope || getRoot();
    if (!root) return;
    root.querySelectorAll('.hl-supplements-card[data-hl-search-brand-product-supplement]').forEach(function (el) {
      el.remove();
    });
  }

  function supplementSearchBrandProducts(searchSource) {
    if (!shouldSupplementSearchBrandProducts(searchSource)) {
      removeSearchBrandProductSupplements();
      return Promise.resolve();
    }
    var params = searchFilterParamsFromSource(searchSource);
    var brand = resolveBrandCollectionForSearchQuery(params.get('q'));
    if (!brand || !brand.handle) return Promise.resolve();

    var root = getRoot();
    var container = root && root.querySelector('.has-sidebar-option > .container');
    if (!container) return Promise.resolve();

    removeSearchBrandProductSupplements(root);

    var seen = new Set();
    container.querySelectorAll('.hl-supplements-card').forEach(function (card) {
      var handle = productHandleFromCard(card);
      if (handle) seen.add(handle);
    });

    return fetchSection('/collections/' + brand.handle, { kind: 'supplement' })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var srcCards = tpl.querySelectorAll('.hl-supplements-card, .thumbnail.column');
        var insertBefore =
          container.querySelector('.hl-search-results__articles') ||
          container.querySelector('p.quote') ||
          container.querySelector('.paginate');
        var frag = document.createDocumentFragment();
        srcCards.forEach(function (card) {
          var handle = productHandleFromCard(card);
          if (!handle || seen.has(handle)) return;
          seen.add(handle);
          var clone = document.importNode(card, true);
          clone.setAttribute('data-hl-search-brand-product-supplement', '');
          frag.appendChild(clone);
        });
        if (!frag.childNodes.length) return;
        if (insertBefore) container.insertBefore(frag, insertBefore);
        else container.appendChild(frag);
        if (window.hlLockApothecaryGridImages) window.hlLockApothecaryGridImages(container);
        applySearchProductFiltersFromUrl(searchSource);
        syncSearchResultsCount();
      })
      .catch(function (err) {
        if (isAbortError(err)) return;
      });
  }
  window.hlSupplementSearchBrandProducts = supplementSearchBrandProducts;

  function scheduleSupplementSearchBrandProducts(searchSource) {
    if (!document.querySelector('[data-hl-search-brand-supplement-mount]')) return;
    var run = function () {
      supplementSearchBrandProducts(searchSource);
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 3000 });
    } else {
      window.setTimeout(run, 2000);
    }
  }
  window.hlScheduleSupplementSearchBrandProducts = scheduleSupplementSearchBrandProducts;

  if (isSearch) {
    blockSearchFacetedHandlers();
    detachOotsFilterHandlers(getRoot());
  }

  document.addEventListener('DOMContentLoaded', function () {
    var scope = getRoot();
    if (!scope) return;
    blockSearchFacetedHandlers();
    syncFilterUi(window.location.search);
    detachOotsFilterHandlers(scope);
    if (!isSearch && window.facetedFiltering && typeof window.facetedFiltering.init === 'function') {
      window.facetedFiltering.init();
    }
    syncCatalogFilterGates(document);
    if (isSearch) {
      syncSearchCatalogTypeFromUrl();
      syncSearchBrandFilterFromUrl();
      syncSearchActiveFilterRow();
      applySearchProductFiltersFromUrl();
      warmSearchSectionFetch();
      scheduleSupplementSearchArticles(window.location.search);
      scheduleSupplementSearchBrandProducts(window.location.search);
      return;
    }
    maybePatchSupplementsGridOnAll(window.location.search)
      .then(function () {
        syncFilterUi(window.location.search);
      })
      .catch(function () {
        syncFilterUi(window.location.search);
      });
  });
  if (!isSearch && window.location.pathname === '/collections/all' && hasSupplementsTypeFilter(window.location.search)) {
    syncFilterUi(window.location.search);
  }
  syncCatalogFilterGates(document);
})();
